module.exports = __webpack_public_path__ + "static/media/Logo_NECTEC-2020_white.7bb81948.png";